/**
 * Fills in browser APIs that SvelteKit, Svelte and our dependencies call
 * unconditionally, for the old browsers and partial headless environments
 * that lack them. Each polyfill is only downloaded when its API is missing.
 * Must run before the router starts, so call it from the client `init` hook.
 */
export const polyfillBrowserApis = async () => {
	// SvelteKit's link handling does `instanceof SVGAElement`; a class nothing
	// is an instance of keeps that check false instead of throwing.
	if (typeof window.SVGAElement === 'undefined') {
		window.SVGAElement = class {} as unknown as typeof SVGAElement;
	}

	// Used by marked (behind <Markdown>), missing before Chrome 92 / Safari 15.4.
	if (typeof Array.prototype.at !== 'function') {
		Object.defineProperty(Array.prototype, 'at', {
			configurable: true,
			writable: true,
			value: function <T>(this: T[], index: number) {
				const i = Math.trunc(index) || 0;
				return this[i < 0 ? this.length + i : i];
			},
		});
	}

	// Used by drop pages' loads (and requireEnv), missing before Chrome 93 /
	// Safari 15.4.
	if (typeof Object.hasOwn !== 'function') {
		Object.defineProperty(Object, 'hasOwn', {
			configurable: true,
			writable: true,
			value: (object: object, key: PropertyKey) =>
				Object.prototype.hasOwnProperty.call(object, key),
		});
	}

	await Promise.all([
		typeof window.ResizeObserver === 'undefined' &&
			import('@juggle/resize-observer').then(({ ResizeObserver }) => {
				window.ResizeObserver = ResizeObserver;
			}),
		// Installs window.IntersectionObserver itself when it is missing.
		typeof window.IntersectionObserver === 'undefined' &&
			import('intersection-observer'),
	]);
};
